<template>
    <div>
        <ConformityCheckListHeaderButton ref="conformityButton" @click="toggleCheckList" />
        <CompassPopover
            class="conformity-popover"
            :isVisible="isVisible"
            triggerRef="conformityButton"
            placement="bottom"
            @close="isVisible = false"
        >
            <div class="conformity-popover__wrapper">
                <h3 class="conformity-popover__title typographies-heading-h3">
                    {{ $t.__('eInvoicing.conformityCheckListHeader.title') }}
                </h3>
                <div class="conformity-popover__introduction typographies-paragraph-medium-regular">
                    <img
                        src="/ressources/logged/img/illustrations/invoicing-signature-blue.svg"
                        :alt="$t.__('eInvoicing.conformityCheckListHeader.title')"
                    />
                    <p>
                        {{ $t.__('eInvoicing.conformityCheckListHeader.description') }}
                    </p>
                </div>
                <CheckList
                    class="conformity-popover__checklist"
                    :items="checkListItems"
                    :loading="isLoading"
                />
                <CompassLink
                    :label="$t.__('eInvoicing.conformityCheckListHeader.link.label')"
                    size="small"
                    link="https://help.sellsy.com/fr/collections/14117844-facturation-electronique"
                    target="_blank"
                />
            </div>
        </CompassPopover>
    </div>
</template>
<script>
import ConformityCheckListHeaderButton from 'vcomponents/eInvoicing/ConformityCheckListHeader/ConformityCheckListHeaderButton.vue';
import CheckList from 'vcomponents/common/CheckList/CheckList.vue';
import { getEInvoicingStatus } from 'api/corp/corp';
export default {
    components: {
        ConformityCheckListHeaderButton,
        CheckList,
    },
    data() {
        return {
            isVisible: false,
            isLoading: false,
            checkListItems: [
                {
                    id: 'pdp_mandates',
                    label: this.$t.__('eInvoicing.conformityCheckListHeader.pdp_mandates.label'),
                },
                {
                    id: 'account_parameters',
                    label: this.$t.__(
                        'eInvoicing.conformityCheckListHeader.account_parameters.label',
                    ),
                },
                {
                    id: 'customers_directory',
                    label: this.$t.__(
                        'eInvoicing.conformityCheckListHeader.customers_directory.label',
                    ),
                },
            ],
        };
    },
    methods: {
        toggleCheckList() {
            this.isVisible = !this.isVisible;

            this.isLoading = true;
            getEInvoicingStatus()
                .then((response) => {
                    this.checkListItems = this.checkListItems.map((item) => {
                        const itemInfo = response.data[item.id];
                        return {
                            ...item,
                            ...itemInfo,
                        };
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.conformity-popover {
    &__wrapper {
        padding: var(--spacing-1);
    }

    &__title {
        margin: 0 0 var(--spacing-1);
    }

    &__introduction {
        color: var(--colors-common-text-subtle-default);
        display: flex;
        gap: var(--spacing-2);
        margin-bottom: var(--spacing-4);

        p {
            margin: 0;
        }
    }

    &__checklist {
        margin-bottom: var(--spacing-5);
    }

    ::v-deep {
        .compass-popover__content {
            width: 400px;
        }
    }
}
</style>
